/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdSearchProps } from './type';

export const searchDefaultProps: TdSearchProps = {
  autofocus: false,
  autoWidth: false,
  borderless: true,
  clearable: true,
  multiline: false,
  readonly: false,
  defaultValue: '',
};
